<!--<button *ngIf="isEditMode" class="btn btn-primary" type="button" (click)="openAddQuestion(addQuestion);">Add Question</button>-->
<ng-template #addQuestion let-modal>
    <div class="modal-header">
        <h4 class="modal-title text-primary" id="modal-basic-title" *ngIf="questionBankDetailsModel">Add This Question To Question Bank "{{questionBankDetailsModel.name}}"</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addQuestionBankQuestionForm" *ngIf="addQuestionBankQuestionForm">
        <div class="modal-body">
            <error-message [errors]="errors"></error-message>
            
            <div class="row form-group">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="col-form-label text-primary">Audit Type</label>
                        <select name="title" class="form-control" formControlName="auditTypeId">
                            <option *ngFor="let auditType of auditTypes" [value]="auditType.id">{{ auditType.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="control-label text-primary">
                        Is Mandatory
                    </label>
                    <input type="checkbox" id="isMandatory" name="isMandatory" class="form-control" formControlName="isMandatory" appToggle />
                    <input name="order" type="hidden" formControlName="zOrder" />
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-danger modal-dismiss mr-1" (click)="modal.close('Close');">Cancel</button>
                    <button type="button" class="btn btn-success modal-dismiss" (click)="addQuestionToQuestionBank();" [disabled]="submitAttempt">Ok</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
